import React, { useContext } from "react";
import { Modal, Form, Select, Input, Button, message } from "antd";
import Cookies from "js-cookie";
import moment from "moment";
import { CommonContext } from "../../Context";
import APIUtils from "../../api/APIUtils";
import WebLinks from "../../api/WebLinks";
import constants from "../../constants/constants";

const { Option } = Select;
const Topup = ({
  open,
  setOpen,
}) => {
  const [formCreate] = Form.useForm();
  const commonContext = useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;
  const options = Array.from({ length: 20 }, (_, i) => (i + 1) * 500);

  const handleCancel = () => {
    formCreate.resetFields();
    setOpen(false);
  };

  const saveDetails = async (values) => {
    const payload = {
      buyerId: buyerId,
      contractAmount: values?.contractAmount,
      invoiceAmount: values?.contractAmount,
      createdByBuyerId: Cookies.get(constants.COOKIE_LOGGED_BUYER_ID),
      purchaseOrderInfo: values?.orderInfo,
      billingDateStart: moment().format("YYYY-MM-DD"),
      billingDateEnd: moment().format("YYYY-MM-DD"),
    };
    const response = await APIUtils.apiCall(
      "POST",
      WebLinks.AddOrderContractAmountDetails,
      JSON.stringify(payload)
    );
    if (!response.isCatch || response.resultObj.statusCode === "2000") {
      commonContext.changeCommonValues(
        {'boostCredits':response.resultObj?.boostCredits || 0}
      );
      handleCancel();
      message.success(response.resultObj.message);
    } else {
      handleCancel();
      message.error(
        response?.resultObj?.message || constants.ERROR_MESSAGE
      );
    }
  };

  return (
    <Modal
      title={constants.BuyBoostCredits}
      open={open}
      onCancel={handleCancel}
      destroyOnClose
      style={{ top: 20 }}
      width={800}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={() => formCreate.submit()}
        >
          Save
        </Button>,
      ]}
    >
      <Form
        form={formCreate}
        name="form_in_modal"
        layout="vertical"
        onFinish={saveDetails}
      >
        <div className="grid xs:grid-cols-1 lg:grid-cols-2 gap-4">
          <Form.Item
            name="contractAmount"
            label="Contract Amount"
            rules={[
              {
                required: true,
                message: "Required field",
              },
            ]}
          >
            <Select placeholder="Choose amount">
            <Option value={10}>{`10`}</Option>
              {options.map((value) => (
                <Option key={value} value={value}>
                  {value}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="orderInfo"
            label="Purchase Order Info."
          >
            <Input placeholder="Order Info." />
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};
export default Topup;
